export const parseFullUserName = (fullName = "") => {
  const splitNameArray = fullName.trim().split(" ");
  const firstName = splitNameArray[0];
  return {
    first: firstName,
    last: splitNameArray[splitNameArray.length - 1],
  };
};
